import noteHistoryLogComponentUrl from './noteHistoryLogComponent.html';

export default {
  bindings: {
    log: '<',
  },
  templateUrl: noteHistoryLogComponentUrl,
  controllerAs: 'ctrl',
};
